export function roundQuantity(value: number, decimals = 3): number {
  const factor = 10 ** decimals;
  return Math.round((value + Number.EPSILON) * factor) / factor;
}

export function formatQuantity(value: number): string {
  return roundQuantity(value).toFixed(3).replace(/\.?0+$/, "");
}
